const themes = [
  {
    id: "default",
    source: {
      palette: {
        text: { secondary: "rgba(0,0,0,0.4)" },
        primary: { main: "#91753b", secondary: "#c0af8e", tertiary: "#f0ede7" },
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              fontSize: "1rem",
            },
          },
        },
        MuiTypography: {
          styleOverrides: {
            root: {
              fontFamily: "pingfang tc",
            },
          },
        },
        MuiAppBar: {
          styleOverrides: {
            root: {
              color: "#000",
              backgroundColor: "#fff",
              boxShadow: "none",
            },
          },
        },
        MuiCardContent: {
          styleOverrides: {
            root: { "&:last-child": { paddingBottom: 0 } },
          },
        },
        MuiFormHelperText: {
          styleOverrides: {
            root: { fontSize: "12px", marginLeft: 0 },
          },
        },
        MuiOutlinedInput: {
          styleOverrides: {
            input: { padding: "12px 8px 12px 14px" },
          },
        },
      },
      typography: {
        fontSize: 12,
        htmlFontSize: 14,
        h6: {
          fontSize: "18px",
          fontWeight: 700,
          whiteSpace: "pre-line",
          letterSpacing: "3px",
          lineHeight: "23px",
        },
        subtitle1: {
          fontSize: "20px",
          whiteSpace: "pre-line",
          lineHeight: "27px",
        },
        subtitle2: {
          fontSize: "16px",
          whiteSpace: "pre-line",
          lineHeight: "23px",
        },
        body1: {
          fontSize: "14px",
          whiteSpace: "pre-line",
          lineHeight: "21px",
        },
        body2: {
          fontSize: "12px",
          whiteSpace: "pre-line",
          lineHeight: "17px",
        },
      },
      zIndex: {
        mobileStepper: 100,
        fab: 105,
        speedDial: 105,
        appBar: 110,
        drawer: 120,
        modal: 130,
        snackbar: 140,
        tooltip: 150,
      },
    },
  },
];

export default themes;
